import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Button, Row, Col } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Field, reduxForm, change } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { NotificationsAPI } from '../Notifications/api/NotificationsAPI';
import { HTMLNotification } from '../Notifications/components/HTMLNotification';
import moment from 'moment';
import 'moment-timezone';
import NotificationsSockets from '../Notifications/api/NotificationsSockets';
import PDFTranscription from './PDFTranscription';
import InfoPatient from '../ClinicHistory/SearchClinicHistory/components/InfoPatient';
import { validateConfigurationsUserProfile } from '../Notifications/api/NotificationsUser';

const Transcription = ({ data, transcriptionOpen, closeTranscription, callbackTranscription, formats, dataPatient }) => {

    //Modal
    const [transcriptionOpened, setTranscriptionOpen] = useState(transcriptionOpen);
    const [transcriptionText, setTranscriptionText] = useState(data.transcripcion != null && data.transcripcion != "null" ? data.transcripcion : null);
    const [userProfile, setUserProfile] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [format, setFormat] = useState(null);
    const [userPermits, setUserPermits] = useState([]);
    const [age, setAge] = useState('');


    const validatePermissionsClinicHistory = () => {
        var user = JSON.parse(sessionStorage.getItem('usuario'));
        if (user != null) {
            if (user.perfil != undefined) {
                var perfil = user.perfil.modulos;

                console.log("userPermits", perfil);
                setUserPermits(perfil);
            } else {
                var perfil = [];
                setUserPermits(perfil);
            }
        } else {
            setUserPermits([]);
        }
    }

    const saveTranscription = async () => {
        let dataSend = {
            id_grabacion: data.id_grabacion,
            transcripcion: transcriptionText,
            id_usuario_transcriptor: JSON.parse(sessionStorage.getItem('usuario')).id_usuario
        };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-audios/guardar-transcripcion', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => response.json()).then(dataRes => {
            sendNotificationToDoctor().then(isNotificated => {
                setTranscriptionOpen(false);
                setTranscriptionText("");
                callbackTranscription(dataRes.grabacion);
            })
        }).catch(error => {
            console.log(error);
        })
    }

    const sendNotificationToDoctor = async () => {
        try {
            //Envia la Notificacion al Doctor de que ya se hizo la Transcripcion y espera una respuesta por parte de el
            validateConfigurationsUserProfile(data.id_usuario_doctor, 1).then((notConfig) => {
                if (notConfig.not_configuracion != null && notConfig.not_configuracion != undefined) {

                    console.log("notConfig",notConfig);


                    let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
                    let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
                    let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
                    let notification = new NotificationsAPI();
                    notification.vista = false;
                    console.log(data.id_usuario_doctor);
                    notification.id_usuario = data.id_usuario_doctor;
                    notification.id_admision = data.id_admision;
                    notification.id_historia = data.id_historia;
                    notification.asunto = "Transcripcion en Revisión";
                    notification.remitente = remitente;
                    notification.notificacion = remitente + ' ha realizado una Transcripcion del Paciente ' + data.nombre_paciente + ' en la Admision ' + data.id_admision;
                    notification.id_notificaciones_tipo = 1;
                    notification.fecha_notificacion = fecha_notificacion;
                    notification.addNotification().then((not) => {
                        let htmlNotificacion = new HTMLNotification();
                        notification.id_notificacion = not.notificacion.id_notificacion;
                        notification.html_notificacion = htmlNotificacion.notificationTranscription(remitente, data.nombre_paciente, data.id_admision, fecha_notificacion);
                        notification.sendHTMLNotification().then((res_not) => {
                            NotificationsSockets.sendNotification(notification);
                            return res_not;
                        }).catch((err) => {
                            console.log(err);
                            return false;
                        });
                    });
                }
            });
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    const sendNotificationDoctorResponse = async (approve) => {
        try {
            let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
            let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
            let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
            let notification = new NotificationsAPI();
            notification.vista = false;
            notification.id_usuario = data.id_usuario_transcriptor;
            notification.id_admision = data.id_admision;
            notification.id_historia = data.id_historia;
            let msjAceptacion = approve == true ? "Aceptada" : "Rechazada";
            notification.asunto = "Transcripcion " + msjAceptacion;
            notification.remitente = remitente;
            let msjContinuo = ' la transcripción del Paciente ' + data.nombre_paciente + ' en la Admision ';
            notification.notificacion = msjAceptacion + msjContinuo + data.id_admision;
            notification.id_notificaciones_tipo = 2;
            notification.fecha_notificacion = fecha_notificacion;
            await notification.addNotification().then((not) => {
                let htmlNotificacion = new HTMLNotification();
                notification.id_notificacion = not.notificacion.id_notificacion;
                notification.html_notificacion = htmlNotificacion.notificationTranscriptionResponseDoctor(fecha_notificacion, msjAceptacion, msjContinuo, data.id_admision);
                notification.sendHTMLNotification().then((res_not) => {
                    NotificationsSockets.sendNotification(notification);
                    return res_not;
                }).catch((err) => {
                    console.log(err);
                    return false;
                });
            });
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    const validateProfile = () => {
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        switch (usuario.id_perfil) {
            case 10://DOCTOR
                setDisabled(true);
                break;
            case 20://TRANSCRIPTOR

                if (data.estado_transcripcion == 2) {
                    setDisabled(true);
                }
                else {
                    setDisabled(false);
                }
                break;
        }
        console.log(data);
        setUserProfile(usuario.id_perfil);
    }

    const changeStatus = async (status) => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}admision-audios/actualizar-estado`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_grabacion: data.id_grabacion, estado_transcripcion: status })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error en el servidor');
            }
        }).then(dataRes => {
            let approve = status == 2 ? true : false;
            sendNotificationDoctorResponse(approve).then(isNotificated => {
                console.log(isNotificated);
                setTranscriptionOpen(false);
                setTranscriptionText("");
                callbackTranscription(dataRes.grabacion);
            })
        }).catch((error) => {
            console.log(error);
        });
    }

    const handleChangeFormat = (formatValue) => {
        setFormat(formatValue);
        setTranscriptionText(formatValue.formato);
    }

    const printTranscription = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + `admision-audios/consultar-impresion?id_admision=${data.id_admision}&id_grabacion=${data.id_grabacion}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(res => {
            let dataQuery = res.info;
            let perfil = JSON.parse(sessionStorage.getItem('clinica'));
            let genderDoctor = dataQuery.sexo_doctor;
            let prefixDoctor = 'Dr. ';
            switch (genderDoctor) {
                case 'Masculino':
                    prefixDoctor = 'Dr. ';
                    break;
                case 'Femenino':
                    prefixDoctor = 'Dra. ';
                    break;
            }
            let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
            let firmDoctor = process.env.REACT_APP_PUBLIC_URL + dataQuery.url_firma_doctor + '/' + sessionStorage.getItem('token');

            console.log("dataQuery", dataQuery.servicio.servicios[0]);

            let nameService = dataQuery.servicio.servicios[0].nombre;
            let codigoService = dataQuery.servicio.servicios[0].codigo;

            const dataPrint = {
                fullname: dataQuery.fullname,
                documentNumber: dataQuery.num_documento,
                typeDocument: dataQuery.tip_documento,
                profile: perfil,
                birthday: moment(dataQuery.fec_nacimiento).format('YYYY-MM-DD'),
                age: dataQuery.edad,
                gender: dataQuery.sexo,
                address: dataQuery.direccion.direccion,
                city: dataQuery.direccion.ciudad,
                telephone: dataQuery.telefono1,
                nitThird: dataQuery.nit_tercero,
                nameThird: dataQuery.nombre_tercero,
                regime: dataQuery.regimen_paciente,
                urlLogo: sessionStorage.getItem('logoURL'),
                transcription: dataQuery.transcripcion,
                nameDoctor: nameDoctor,
                specialtyDoctor: dataQuery.especialidad_doctor,
                medicalRegister: dataQuery.reg_medico,
                urlDoctorFirm: firmDoctor,
                nameService: nameService,
                codigoService: codigoService,
                id_admision: data.id_admision
            };
            //this.setState({ showPDf: true });
            PDFTranscription(dataPrint);
        }).catch(error => {
            console.log(error);
        });
    }

    const getServiceHeader = () => {

    }

    const calculateAge = (birthday) => {

        let hoy = new Date();
        let cumpleanos = new Date(birthday);

        let edad = hoy.getFullYear() - cumpleanos.getFullYear();

        let meses = hoy.getMonth() - cumpleanos.getMonth();


        if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }

        let cantMeses = meses;

        if (meses < 0) {
            cantMeses = 12 + meses;
        }

        let edadTotal = edad + ' años ';

        let fecha = moment(birthday, "YYYYMMDD").fromNow(true);

        setAge(edadTotal);
    }
    useEffect(() => {
        validateProfile();
        validatePermissionsClinicHistory();
        if (dataPatient !== null && dataPatient !== undefined) {
            calculateAge(dataPatient.birthday);
        }
        console.log("DATACOMINGTRANSCRIPTION", data)
        console.log("DATApatient", dataPatient)

    }, []);

    return (
        <Fragment>
            <Modal
                open={transcriptionOpened}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: 1000, margin: 10 }}>
                    <div className="card__title">
                        <h4 className="bold-text">Transcripción</h4>
                    </div>
                    {
                        dataPatient !== null && dataPatient !== undefined ?
                            <Fragment>
                                <InfoPatient dataPatient={dataPatient} />
                            </Fragment>
                            : null
                    }
                    <div style={{ marginTop: 10 }}>
                        <Row>
                            <Col md={data.estado_transcripcion != 1 && data.estado_transcripcion != 3 ? 12 : 6}>
                                <h6 className="bold-text">Audio</h6>
                                <br />
                                <audio
                                    style={{ width: '100%' }}
                                    controls
                                    src={process.env.REACT_APP_PUBLIC_URL + data.url_archivo + "/" + sessionStorage.getItem('token')}
                                ></audio>
                            </Col>
                            {data.estado_transcripcion != 1 && data.estado_transcripcion != 3 ? null : <Col md={6}>
                                <h6 className="bold-text">Formato de Transcripción</h6>
                                <br />
                                <TextField
                                    className="medical-material-form__field"
                                    id="transcriptionFormat"
                                    label="Formato de Transcripción"
                                    select
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    disabled={data.estado_transcripcion != 1 && data.estado_transcripcion != 3}
                                    value={format}
                                    onChange={(e) => {
                                        handleChangeFormat(e.target.value);
                                    }}
                                >
                                    {formats.map((format) => {
                                        return <MenuItem key={format.id_formato} value={format}>{format.nombre}</MenuItem>
                                    })}
                                </TextField>
                            </Col>}
                        </Row>
                        <br /><br />
                        <div className="form" style={{ width: '100%' }}>
                            <div className="form__half" style={{ width: '100%' }}>
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Transcripción</span>
                                    <div className="form__form-group-field">
                                        <textarea disabled={disabled || (data.estado_transcripcion != 1 && data.estado_transcripcion != 3)} style={{ width: '100%', height: '200px' }} value={transcriptionText} onChange={(event) => { setTranscriptionText(event.target.value) }} required={true}>
                                        </textarea>
                                    </div>
                                </div>
                            </div></div>

                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            color="secondary"
                            onClick={() => {
                                closeTranscription();
                            }}
                        >
                            Cerrar
                        </Button>
                        {
                            //Si es un Transcriptor y el Estado esta en Pendiente
                            (data.estado_transcripcion == 1 || data.estado_transcripcion == 3) && (userPermits.includes(30)) ? <>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="primary"
                                    onClick={() => {
                                        saveTranscription();
                                    }}
                                >
                                    Guardar para Revisión
                                </Button>
                            </> : null
                        }
                        {
                            //Si es un Doctor puede Aprobar o Rechazar
                            (data.estado_transcripcion == 1 || data.estado_transcripcion == 3) && (userPermits.includes(31)) ? <>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="success"
                                    onClick={() => {
                                        changeStatus(2);
                                    }}
                                >
                                    Aprobar
                                </Button>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="danger"
                                    onClick={() => {
                                        changeStatus(3);
                                    }}
                                >
                                    Rechazar
                                </Button>
                            </> : null
                        }
                        {
                            data.estado_transcripcion == 2 ? <Button
                                style={{ marginTop: 10 }}
                                color="primary"
                                onClick={() => {
                                    printTranscription();
                                }}
                            >
                                Imprimir
                            </Button> : null
                        }
                    </div>
                </div>
            </Modal>
        </Fragment>)
}

export default reduxForm({
    form: `transcription-form`, // a unique identifier for this form
})(withTranslation('common')(Transcription));